import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./DesktopNavbar.css";

function DesktopNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    // Return false for home page and footer link
    if (path === "/" || location.pathname === "/") {
      return false;
    }
    return location.pathname === path ? "active-link" : "inactive-link";
  };

  const scrollToFooter = () => {
    navigate("/");
    setTimeout(() => {
      const footerElement = document.getElementById("footer");
      if (footerElement) {
        footerElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  const navItems = [
    { text: "אודות", link: "/about" },
    { text: "פתרונות LeetCode", link: "/VlogListLeetCode" },
    { text: "ארכיטקטורת קוד", link: "/VlogListCodeArchitecture" },
    { text: "וולוגים", link: "/VlogListAllVlogs" },
    { text: "איפה עוד אפשר למצוא אותי?", link: "/", onClick: scrollToFooter },
  ];

  return (
    <Navbar expand="lg" className="py-3 px-4 bg-navbar sticky-top">
      <Navbar.Brand as={Link} to="/" className="text-white navbar-text mx-3">
        פינתי
      </Navbar.Brand>
      <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-block">
        <Nav as="ul">
          {navItems.map((item, index) => (
            <Nav.Item key={index} as="li" className="mx-1">
              <Nav.Link
                as={Link}
                to={item.link}
                onClick={item.onClick}
                className={`navbar-text ${isActive(item.link)}`}
              >
                {item.text}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default DesktopNavbar;
